var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { COLORS } from '../../themes';
export var TableBorders = function (props) {
    var styleObj = {};
    styleObj.height = props.height ? "".concat(props.height, "px") : '100%';
    if (props.maxHeight) {
        styleObj.maxHeight = "".concat(props.maxHeight, "px");
    }
    return __assign({ border: "1px solid ".concat(COLORS.tagBoxDefault), overflow: 'hidden', borderRadius: '8px', width: '100%' }, styleObj);
};
export var TableWrapper = function (props) {
    // if no data, there will be no pagination
    var styleObj = {};
    if (props.height) {
        styleObj.height = props.noData ? props.height : "".concat(props.height - 67, "px");
    }
    else {
        styleObj.height = 'max-content';
        styleObj.maxHeight = props.noData ? '100%' : "calc(100% - 67px)";
    }
    return __assign({ overflow: 'hidden', width: '100%', display: 'flex' }, styleObj);
};
export var SelectWrapperOuter = function (props) {
    var styleObj = {};
    if (!props.isWidthPercentageActive) {
        styleObj.boxShadow = "0px -6px 8px rgba(0, 0, 0, 0.15)";
    }
    return __assign({ width: '48px', borderRight: COLORS.reddishGray, overflow: 'hidden', zIndex: 1 }, styleObj);
};
export var ActionsWrapper = function (props) {
    var styleObj = {};
    if (!props.isWidthPercentageActive) {
        styleObj.boxShadow = "0px -5px 8px rgba(0, 0, 0, 0.15)";
    }
    return __assign({ width: 'max-content', borderRight: COLORS.reddishGray, overflow: 'auto', zIndex: 1 }, styleObj);
};
export var TableColumns3rdWrapper = function (props) {
    var styleObj = {};
    styleObj.overflowX = props.isWidthPercentageActive ? 'hidden' : 'scroll';
    if (!props.isWidthPercentageActive) {
        styleObj.overscrollBehaviorX = 'contain';
    }
    return __assign({ flex: 1, overflowY: 'hidden', position: 'relative' }, styleObj);
};
export var TableColumns2ndWrapper = function (props) {
    var styleObj = {};
    styleObj.width = props.isWidthPercentageActive
        ? '100%'
        : "".concat(props.width - 15, "px");
    return __assign({ height: '100%', overflow: 'hidden' }, styleObj);
};
export var TableColumnsWrapper = function (props) {
    var styleObj = {};
    styleObj.width = props.isWidthPercentageActive
        ? 'calc(100% + 15px)'
        : 'max-content';
    return __assign({ height: '100%', overflowY: 'scroll', paddingRight: '15px', boxSizing: 'border-box' }, styleObj);
};
export var TableColumn = function (props) {
    var styleObj = {};
    if (props.widthPercentage) {
        styleObj.width = props.widthPercentage;
    }
    return __assign({ minWidth: 'max-content' }, styleObj);
};
export var ActionHeaderItem = function (props) {
    return {
        height: '56px',
        borderBottom: "1px solid ".concat(COLORS.tagBoxDefault),
        padding: '16px',
        position: 'absolute',
        backgroundColor: COLORS.onPrimary,
        fontWeight: '700',
        textAlign: 'right',
        borderTopRightRadius: '8px',
        width: props.width,
        boxSizing: 'border-box',
    };
};
export var HeaderItemWrapper = function (props) {
    var styleObj = {};
    if (props.width) {
        styleObj.width = "".concat(props.width, "px");
    }
    if (props.textAlign) {
        styleObj.textAlign = props.textAlign;
    }
    return __assign({ height: '56px', padding: '16px', borderBottom: "1px solid ".concat(COLORS.tagBoxDefault), position: 'absolute', zIndex: 0, backgroundColor: COLORS.onPrimary, boxSizing: 'border-box' }, styleObj);
};
export var RowItemWrapper = function (props) {
    var styleObj = {};
    if (props.selected) {
        styleObj.background = COLORS.bluishGray;
    }
    if (props.handleClickRowFunctionAvailable) {
        styleObj.cursor = 'pointer';
    }
    if (props.textAlign) {
        styleObj.textAlign = props.textAlign;
    }
    return __assign({ height: '62px', borderBottom: "1px solid ".concat(COLORS.tagBoxDefault), padding: '16px', boxSizing: 'border-box', display: 'flex', alignItems: 'center' }, styleObj);
};
export var SideRowItem = function (props) {
    var styleObj = {};
    if (props.selected) {
        styleObj.background = COLORS.bluishGray;
    }
    return __assign({ height: '62px', borderBottom: "1px solid ".concat(COLORS.tagBoxDefault), padding: '16px', boxSizing: 'border-box', display: 'flex', alignItems: 'center', justifyContent: 'end' }, styleObj);
};
export var TableStyles = {
    SelectWrapper: {
        width: '63px',
        overflow: 'hidden',
        paddingRight: '15px',
        height: '100%',
        boxSizing: 'border-box',
    },
    ActionsColumn: {
        height: 'max-content',
    },
    SelectHeaderItem: {
        height: '56px',
        borderBottom: "1px solid ".concat(COLORS.tagBoxDefault),
        padding: '16px',
        position: 'absolute',
        backgroundColor: COLORS.onPrimary,
        width: '48px',
        borderTopLeftRadius: '8px',
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        marginLeft: '3px',
    },
    HeaderItem: {
        width: 'max-content',
        fontWeight: '700',
        display: 'flex',
        alignItems: 'center',
        color: '#000000',
    },
    HeaderItemPositionAdjustment: {
        height: '56px',
        padding: '16px',
        fontWeight: '700',
        color: COLORS.onPrimary,
        boxSizing: 'border-box',
    },
    RowItem: {
        width: 'max-content',
    },
    WidthMaxContent: {
        width: 'max-content',
    },
    ActionButtonsWrapper: {
        display: 'flex',
        gap: '8px',
    },
    ChevronWrapper: {
        flexGrow: 1,
        paddingLeft: '10px',
        cursor: 'pointer',
    },
    UpChevron: {
        transform: 'scale(2, 1)',
        height: '9px',
        fontSize: '7px',
    },
    DownChevron: {
        transform: 'scale(2, 1) rotate(180deg)',
        height: '9px',
        fontSize: '7px',
    },
    TableColumnsWrapperInner: {
        display: 'flex',
    },
    NoRecordFound: {
        height: '70px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
};
